


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CategoryCheckbox extends Vue {
  @Prop() private value!: string[];
  @Prop({ required: true }) private categoryId!: string;
  @Prop({ required: true }) private categoryLabel!: string;
  private checkedProxy = false;

  created() {
    // set the checked proxy if we start with this value included.
    if (this.value.includes(this.categoryId)) {
      this.checkedProxy = true;
    }
  }

  public onClick() {
    this.checkedProxy = !this.checkedProxy;
    const arr: string[] = [];
    let v = arr.concat(this.value); // copy so we dont mutate directly
    if (!this.checkedProxy && v.includes(this.categoryId)) {
      v.splice(v.indexOf(this.categoryId), 1);
    } else {
      v.push(this.categoryId);
    }
    this.$emit("input", v); // emit the new value.
  }
}
